import React, {useEffect, useMemo, useState} from 'react';
import Box from "@mui/material/Box";
import TableMinSigners from "../../../../components/TableCustom/TableMinSigners";
import {Button, Grid, Typography} from "@mui/material";
import {confirmWarning} from "../../../../components/Popups/message/PopupWarning";
import {checkRoles} from "../../../../functions/checkRoles";
import EmployeeField from "../../../../components/Fields/EmployeeField";
import {v4 as uuidv4} from "uuid";

const AddSigners = ({signers, setSigners, handleSigners, handleSignersSeby, employee, employeeCount, activeStep, handleBack, handleNext, steps, localFilial}) => {

    const [approverId, setApproverId] = useState('');
    const [approverObj, setApproverObj] = useState(null);

    // Автоподбор утверждающего
    useEffect(() => {
        if (!employee?.length) return;
        // Если выбран не филиал (ЦА): берём председателя правления
        // Эвристика: позиция содержит "председатель" или code === 'generalnyi_direktor'
        // Иначе: директор филиала по filialId
        let found = null;
        if (!localFilial) {
            found = employee.find(e =>
                (e?.position?.name || '').toLowerCase().includes('председатель') ||
                (e?.position?.code || '') === 'generalnyi_direktor'
            );
        } else {
            found = employee.find(e =>
                Number(e?.filialId) === Number(localFilial) &&
                (e?.position?.name || '').toLowerCase().includes('директор')
            );
        }
        if (found) {
            setApproverId(found.id);
            setApproverObj(found);
        }
    }, [employee, localFilial]);

    const handleApproverChange = (emp) => {
        const positionName = (emp?.position?.name || '').toLowerCase();
        const isCentral = Number(localFilial) === 1;
        const validForCentral = positionName.includes('председатель');
        const validForFilial = positionName.includes('директор');
        if ((isCentral && !validForCentral) || (!isCentral && !validForFilial)) {
            confirmWarning(
                isCentral
                    ? 'Для ЦА выберите сотрудника с должностью "Председатель правления"'
                    : 'Для филиала выберите сотрудника с должностью "Директор"',
                () => {}
            );
            return;
        }
        setApproverId(emp.id);
        setApproverObj(emp);
    };

    const ensureApproverInSigners = () => {
        if (!approverId) return;
        const exists = signers.some(s => s.employeeId === approverId && s.isApprover);
        if (!exists) {
            const newElement = {
                Id: uuidv4(),
                employeeId: approverId,
                employee: approverObj,
                isSigned: false,
                isApprover: true
            };
            setSigners(old => [newElement, ...old]);
        }
    };

    return (
        <Box component="form"
             sx={{mt: 1, display: 'flex', padding: '0px 10px', flexWrap: 'wrap'}}>
            <Box sx={{width: '100%', mb: 2}}>
                <Typography sx={{mb: 1, fontWeight: 600}}>Утверждающий</Typography>
                <EmployeeField
                    fullWidth
                    object={approverObj}
                    value={approverId}
                    extraFilter={{
                        ...(localFilial && {
                            filialId: {
                                operand1: localFilial,
                                operator: "equals"
                            }
                        })
                    }}
                    onChange={handleApproverChange}
                />
            </Box>
            <TableMinSigners edit employee={employee} employeeCount={employeeCount} signers={signers} setSigners={setSigners}/>
            <Button onClick={handleSigners}>Добавить блок</Button>
            <Button onClick={handleSignersSeby}>Добавить себя</Button>
            <Box sx={{width: '100%', mt: 10}}>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <Button
                            fullWidth
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            variant="contained"
                        >
                            Назад
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            fullWidth
                            onClick={() => { ensureApproverInSigners(); handleNext(); }}
                            variant="contained"
                        >
                            {activeStep === steps.length - 1 ? 'Завершить' : 'Далее'}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default AddSigners;
